








import { createComponent } from "@vue/composition-api";
import { useDictionary } from "../views/compositions/useDictionary";
export default createComponent({
  props: {
    days: {
      type: Number,
      required: true
    }
  },
  setup(props: { days: number }) {
    const dictionary = useDictionary();
    const dayText =
      props.days > 1
        ? dictionary.dictionary.DCC_PlanResults_DrinkFreeDayEachWeek
        : dictionary.dictionary.DCC_PlanResults_DrinkFreeDayEachWeek.replace(
            "Days",
            "Day"
          );

    return {
      ...dictionary,
      dayText
    };
  }
});
